// extracted by mini-css-extract-plugin
export default {"cardDefault":"Card_cardDefault__A1EzL","column":"Card_column__wwW5T"};